import { render, staticRenderFns } from "./MentorBasicInfo.vue?vue&type=template&id=483af354&scoped=true&"
import script from "./MentorBasicInfo.vue?vue&type=script&lang=js&"
export * from "./MentorBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483af354",
  null
  
)

export default component.exports